import ScrollableContainer from "../../../Component/BonusUi/Scrollable/Scrollable";

const Scrollable = () => {
  return (
    <div className="page-body">
      <ScrollableContainer />
    </div>
  );
};

export default Scrollable;
